if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}

(() => {
  if (!('IntersectionObserver' in window)) return;
  const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
  const page = document.documentElement;

  document.querySelectorAll('#MainContent product-form').forEach((form) => {
    const info = form.closest('.product__info-container');
    const control = form.querySelector('.sg-motion-toggle');
    if (!info || !control || form.sgProductMotionReady) return;
    form.sgProductMotionReady = true;

    const buttonSelector = '.shopify-payment-button__button--unbranded';
    const blocked = '[disabled], [aria-disabled="true"], [aria-busy="true"], .loading';
    const buttons = new Set();
    const visible = new WeakSet();
    const typed = new WeakSet();
    const typing = new Map();
    const lines = [];
    const paused = () => page.dataset.sgProductAnimationsPaused === 'true';
    const permitted = () => !paused() && !preference.matches && !document.hidden;
    const unavailable = (button) =>
      !button.isConnected || button.closest(blocked) || form.querySelector('.product-form__submit')?.matches(blocked);

    const finish = (line) => {
      clearInterval(typing.get(line));
      typing.delete(line);
      line.classList.remove('sg-typewriter-running');
      line.querySelector('.sg-customisation__visual').textContent = '';
    };

    const startTyping = (line) => {
      if (typed.has(line) || !visible.has(line) || !permitted()) return;
      typed.add(line);
      const label = line.querySelector('.sg-customisation__label');
      const visual = line.querySelector('.sg-customisation__visual');
      const characters = Array.from(label.textContent.trim());
      let count = 0;
      line.classList.add('sg-typewriter-running');
      typing.set(line, setInterval(() => {
        visual.textContent = characters.slice(0, ++count).join('');
        if (count >= characters.length) finish(line);
      }, 45));
    };

    const update = () => {
      if (control.hidden !== preference.matches) control.hidden = preference.matches;
      const label = paused() ? control.dataset.resumeLabel : control.dataset.pauseLabel;
      if (control.textContent !== label) control.textContent = label;
      if (control.getAttribute('aria-pressed') !== String(paused())) control.setAttribute('aria-pressed', String(paused()));
      buttons.forEach((button) => {
        button.classList.toggle('sg-buy-now-visible', permitted() && visible.has(button) && !unavailable(button));
      });
      if (!permitted()) typing.forEach((timer, line) => finish(line));
      else lines.forEach(startTyping);
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && entry.intersectionRatio >= 0.5) visible.add(entry.target);
        else {
          visible.delete(entry.target);
          if (typing.has(entry.target)) finish(entry.target);
        }
      });
      update();
    }, { threshold: 0.5 });

    info.querySelectorAll('.product__text').forEach((line) => {
      if (line.textContent.trim().replace(/\s+/g, ' ') !== 'Fully customisable at no extra cost') return;
      const label = document.createElement('span');
      label.className = 'sg-customisation__label';
      while (line.firstChild) label.appendChild(line.firstChild);
      const visual = document.createElement('span');
      visual.className = 'sg-customisation__visual';
      visual.setAttribute('aria-hidden', 'true');
      line.append(label, visual);
      line.classList.add('sg-customisation');
      lines.push(line);
      observer.observe(line);
    });

    const discover = () => {
      buttons.forEach((button) => {
        if (!button.isConnected) {
          observer.unobserve(button);
          buttons.delete(button);
        }
      });
      form.querySelectorAll(buttonSelector).forEach((button) => {
        if (!buttons.has(button)) {
          buttons.add(button);
          observer.observe(button);
        }
      });
      update();
    };

    control.addEventListener('click', () => {
      page.dataset.sgProductAnimationsPaused = String(!paused());
      document.dispatchEvent(new Event('sg:product-motion-change'));
    });
    document.addEventListener('sg:product-motion-change', update);
    document.addEventListener('visibilitychange', update);
    preference.addEventListener('change', update);
    new MutationObserver(discover).observe(form, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['disabled', 'aria-disabled', 'aria-busy', 'class', 'hidden'],
    });
    discover();
  });
})();
